package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.ImageAddOutline: ImageVector
    get() {
        if (_imageAddOutline != null) {
            return _imageAddOutline!!
        }
        _imageAddOutline = Builder(name = "ImageAddOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 15.0f, viewportHeight = 15.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(1.5064f, 14.1666f)
                curveTo(1.0855f, 14.1666f, 0.7292f, 14.0208f, 0.4375f, 13.7291f)
                curveTo(0.1458f, 13.4374f, 0.0f, 13.0811f, 0.0f, 12.6602f)
                verticalLineTo(1.5064f)
                curveTo(0.0f, 1.0855f, 0.1458f, 0.7292f, 0.4375f, 0.4375f)
                curveTo(0.7292f, 0.1458f, 1.0855f, 0.0f, 1.5064f, 0.0f)
                horizontalLineTo(7.7564f)
                curveTo(7.7564f, 0.1827f, 7.7564f, 0.3769f, 7.7564f, 0.5825f)
                curveTo(7.7564f, 0.7882f, 7.7564f, 1.0107f, 7.7564f, 1.25f)
                horizontalLineTo(1.5064f)
                curveTo(1.4316f, 1.25f, 1.3702f, 1.274f, 1.3221f, 1.3221f)
                curveTo(1.274f, 1.3702f, 1.25f, 1.4316f, 1.25f, 1.5064f)
                verticalLineTo(12.6602f)
                curveTo(1.25f, 12.735f, 1.274f, 12.7964f, 1.3221f, 12.8445f)
                curveTo(1.3702f, 12.8926f, 1.4316f, 12.9166f, 1.5064f, 12.9166f)
                horizontalLineTo(12.6602f)
                curveTo(12.735f, 12.9166f, 12.7964f, 12.8926f, 12.8445f, 12.8445f)
                curveTo(12.8926f, 12.7964f, 12.9166f, 12.735f, 12.9166f, 12.6602f)
                verticalLineTo(6.4102f)
                curveTo(13.1559f, 6.4102f, 13.3784f, 6.4102f, 13.5841f, 6.4102f)
                curveTo(13.7897f, 6.4102f, 13.9839f, 6.4102f, 14.1666f, 6.4102f)
                verticalLineTo(12.6602f)
                curveTo(14.1666f, 13.0811f, 14.0208f, 13.4374f, 13.7291f, 13.7291f)
                curveTo(13.4374f, 14.0208f, 13.0811f, 14.1666f, 12.6602f, 14.1666f)
                horizontalLineTo(1.5064f)
                close()
                moveTo(2.4038f, 10.9935f)
                horizontalLineTo(11.7628f)
                lineTo(8.8541f, 7.1154f)
                lineTo(6.3541f, 10.3605f)
                lineTo(4.5833f, 8.109f)
                lineTo(2.4038f, 10.9935f)
                close()
                moveTo(11.25f, 4.5833f)
                verticalLineTo(2.9166f)
                horizontalLineTo(9.5833f)
                verticalLineTo(1.6667f)
                horizontalLineTo(11.25f)
                verticalLineTo(0.0f)
                horizontalLineTo(12.4999f)
                verticalLineTo(1.6667f)
                horizontalLineTo(14.1666f)
                verticalLineTo(2.9166f)
                horizontalLineTo(12.4999f)
                verticalLineTo(4.5833f)
                horizontalLineTo(11.25f)
                close()
            }
        }
        .build()
        return _imageAddOutline!!
    }

private var _imageAddOutline: ImageVector? = null
